/* Keep an incoming repair-assessment link at its heading while the app mounts.
 * Stop after initialization or any visitor interaction; never change form focus.
 */
(function () {
  'use strict';
  var hash = '#repair-assessment-form';
  var cancel = function () {};

  function start() {
    cancel();
    var anchor = document.getElementById('repair-assessment-form');
    var section = anchor && anchor.closest('.shopify-section');
    var heading = section && section.querySelector('h1');
    if (!section || !heading) return;

    var stopped = false;
    var frame = 0;
    var settledTimer;
    var deadlineTimer;
    var observer;
    var resizeObserver;
    var interactionEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown', 'focusin'];

    function stop() {
      if (stopped) return;
      stopped = true;
      cancelAnimationFrame(frame);
      clearTimeout(settledTimer);
      clearTimeout(deadlineTimer);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      interactionEvents.forEach(function (name) { document.removeEventListener(name, stop, true); });
      window.removeEventListener('load', schedule);
      window.removeEventListener('pagehide', stop);
    }

    function align() {
      if (stopped || !heading.isConnected) return;
      // The real heading has a visible box; the original fragment is an empty span.
      // scrollIntoView respects the theme's sticky-header scroll padding.
      heading.scrollIntoView({ block: 'start', behavior: 'instant' });
    }

    function schedule() {
      if (stopped) return;
      cancelAnimationFrame(frame);
      clearTimeout(settledTimer);
      frame = requestAnimationFrame(function () {
        align();
        var field = section.querySelector('#globo-formbuilder-163971 input, .globo-formbuilder input');
        if (field && document.readyState === 'complete') {
          // One final alignment catches a late app/native-fragment scroll after render.
          settledTimer = setTimeout(function () { align(); stop(); }, 2000);
        }
      });
    }

    cancel = stop;
    interactionEvents.forEach(function (name) {
      document.addEventListener(name, stop, { capture: true, passive: true });
    });
    if (window.MutationObserver) {
      observer = new MutationObserver(schedule);
      observer.observe(section, { childList: true, subtree: true });
    }
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(section);
    }
    window.addEventListener('load', schedule);
    window.addEventListener('pagehide', stop);
    // An unavailable third-party app must not leave automatic scrolling active.
    deadlineTimer = setTimeout(stop, 30000);
    schedule();
  }

  function followHash() {
    if (window.location.hash === hash) start();
    else cancel();
  }
  window.addEventListener('hashchange', followHash);
  document.addEventListener('hashchange:simulate', function (event) {
    if (event.detail && event.detail.hash === hash) start();
    else cancel();
  });
  followHash();
}());
